import { ErrorMessage, Field } from '@atlaskit/form';
import Select, { OptionsType, ValueType } from '@atlaskit/select';
import React from 'react';
import { ReasonCodeSelect } from '@atlassian/cssxp-types-billing';

interface Props {
  fieldName?: string;
  fieldLabel?: string;
  isRequired?: boolean;
  options: OptionsType<ReasonCodeSelect>;
  isDisabled?: boolean;
}

export const InvoiceRefundReasonFormField = ({
  fieldName = 'refundReason',
  fieldLabel = 'Refund reason',
  isRequired = false,
  options,
  isDisabled = false,
}: Props) => {
  return (
    <>
      <Field<ValueType<ReasonCodeSelect>>
        name={fieldName}
        label={fieldLabel}
        isRequired={isRequired}
        validate={(value: any) => (!value ? 'EMPTY' : undefined)}
        defaultValue={options && options.length === 1 ? options[0] : null}
        isDisabled={isDisabled}
      >
        {({ fieldProps, error }) => (
          <div data-testid="refund-reason-field">
            <Select<ReasonCodeSelect>
              {...fieldProps}
              id={fieldProps.id}
              className="refund-reason-field"
              classNamePrefix="refund-reason-each-field"
              spacing="compact"
              isSearchable={false}
              options={options}
              placeholder="Select the reason for this refund"
              validationState={error ? 'error' : 'default'}
            />
            {error && <ErrorMessage>Please select the reason for refund</ErrorMessage>}
          </div>
        )}
      </Field>
    </>
  );
};
